import React, {Component} from "react";
import { connect } from 'react-redux';
import MusicGrid from '../../components/MusicGrid';
import Resume from '../../components/Resume';
import Spinner from './../../components/Spinner';
import MusicUtils from "../../actions/musica/music-actions";
import MusicActions from '../../components/MusicActions';
import { fetchLoginDynamic } from '../../reducers/user';
import { setResumeData } from "../../actions/resume";
import { doPGMRadio } from '../../actions/musica/player-shared-action-creators';
import logger from 'src/utils/logger/logger';
import { playFullMedia } from '../../actions/playmedia';
import * as api from '../../requests/loader';
import MusicActionsUtil from '../../utils/music/MusicActionsUtil';
import GenRadiosDetailAdapter from './GenRadiosDetailAdapter';

class GenreRadioList extends Component {
  constructor(props) {
    super(props);
    this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
    this.state = {
      user: props.user,
      isFetching: false,
      genreRadios: [],
      selectedRadio: {},
      pgm: null,
    };
    this.intervalRadios = null;
    this.handlePlay = this.handlePlay.bind(this);
    this.toggleFollow = this.toggleFollow.bind(this);
  }

  onFocusCardHandler(data, index) {
    if (this.idTimeout) {
      clearTimeout(this.idTimeout);
    }

    this.idTimeout = setTimeout(()=>{
      const elements = document.getElementsByClassName('focused');
      if(elements.length > 0)
        elements[0].classList.remove('focused');

      const selEl= document.getElementById(`card-${data.id}`);
      if(selEl){
        selEl.classList.add("focused");
      }

      const itemData = {
        title: this.props.match.params.name,
        year: data.name,
        rating: data.rating_code,
        category: data.artist || data.author,
        duration: data.title,
        showBack: false,
        purchaseButtonInfo: true,
      };
      this.setState({
        selectedRadio: data
      });
      this.props.setResumeData({...itemData, overWrite: true});
    }, 500);
  }

  parseItem = items =>
    items.map(it => {
      it.id = it.entity_id;
      it.isFollowing = it.isFavorite;
      delete it.isFavorite;

      return it;
  });

  fetchGenreRadios(user) {
    const genreName = this.props.match.params.name;
    api.getGenreRadios({
        genre: genreName
    })
    .then(resp => {
        let itemsResult = GenRadiosDetailAdapter(resp);
        this.setState({
            genreRadios: this.parseItem(itemsResult)
        });
    })
    .catch(err => {
        logger.error('Fail ribbons: ' + err);
    });
  }

  toggleFollow() {
    const { selectedRadio } = this.state;
    MusicActionsUtil.toggleFollow({
        type: selectedRadio.type,
        id: selectedRadio.id,
        isFollowing: selectedRadio.isFollowing
    }).then(result => {
        this.setState(prevState => ({
            selectedRadio: {
                ...prevState.selectedRadio,
                isFollowing: !prevState.selectedRadio.isFollowing
            }
        }));
    });
  }

  sendToPlay = (pgm) => {
    if(pgm) {
      this.props.playFullMedia({
        playerstate: 'PLAYING',
        source: {
          audiosource: pgm.media.video_url
        },
        ispreview: false,
        islive: false,
        ispip: false,
      });
    }
  }

  handlePlay(){
    if(!this.state.selectedRadio.url) {
      MusicUtils.getRadioDetailFromCard(this.state.selectedRadio.id, this.props.user.musicUser).then(radio =>{
        const pgm = this.props.onPlayRadio(radio.url, radio);
        this.sendToPlay(pgm);
      });
    } else {
      const pgm = this.props.onPlayRadio(this.state.selectedRadio.url, this.state.selectedRadio);
      this.sendToPlay(pgm);
    }
  }

  componentWillMount() {
    if(this.props.user.musicUser === undefined){
      this.props.fetchLoginDynamic(this.state.user.email);
      this.setState({user: this.props.user});
    }
  }

  componentDidMount(){
    this.fetchGenreRadios();
  }

  componentWillReceiveProps(nextProps){
    this.fetchGenreRadios();
  }

  componentWillUnmount(){
    clearInterval(this.intervalRadios);
  }

  render() {
    return (
      <div className="radios-container-inter">
        <Resume />
        { this.state.genreRadios.length === 0 ? <Spinner /> : ''}
        <MusicGrid
          items={this.state.genreRadios}
          gridType="radio"
          service="Radios"
          type="square"
          onFocusHandler={this.onFocusCardHandler}
        />
        <MusicActions
          actionType="radios"
          buttonData={this.state.selectedRadio}
          blueAction={this.handlePlay}
          yellowAction={this.toggleFollow}
          isHidden={true}
          device={MusicUtils.getMusicDevice()}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({ user: state.user, playerMusica: state.playermusica });
const mapDispatchToProps = dispatch => ({
  fetchLoginDynamic: (email) => dispatch(fetchLoginDynamic(email)),
  setResumeData: (itemData) => dispatch(setResumeData(itemData)),
  onPlayRadio: (index,state) => dispatch(doPGMRadio(index, state)),
  playFullMedia: (pgm) => dispatch(playFullMedia(pgm))
});
export default connect(mapStateToProps, mapDispatchToProps)(GenreRadioList);



// WEBPACK FOOTER //
// ./src/components/GenreRadioList/index.jsx